import { SVGAttributes } from 'react';

export default function (props: SVGAttributes<SVGElement>) {
    return (
        <svg width="18px" height="16px" viewBox="0 0 18 16" version="1.1" xmlns="http://www.w3.org/2000/svg" {...props}>
            <title>Update / real-estate-update-house-sync</title>
            <g
                id="Content-/-Tile"
                stroke="none"
                strokeWidth="1"
                fill="none"
                fillRule="evenodd"
                strokeLinecap="round"
                strokeLinejoin="round"
            >
                <g
                    id="Content-/-Tile-/-Default-/-Rental-unit"
                    transform="translate(-371.000000, -306.000000)"
                    fillRule="nonzero"
                    stroke="#FFFFFF"
                    strokeWidth="1.5"
                >
                    <g
                        id="Actions-/-Button-/-Primary-/-Large-/-With-Icon"
                        transform="translate(360.000000, 300.000000)"
                    >
                        <g id="Group" transform="translate(12.000000, 0.000000)">
                            <g transform="translate(0.000000, 6.000000)" id="Update-/-real-estate-update-house-sync">
                                <g id="Regular" transform="translate(0.000000, 1.333333)">
                                    <path
                                        d="M12,1.37733333 C10.0415957,-0.151632211 7.38291705,-0.430446022 5.14992481,0.658970637 C2.91693257,1.7483873 1.50030911,4.01543104 1.5,6.5 L1.5,8"
                                        id="Shape"
                                    />
                                    <path
                                        d="M4,11.626 C5.95901195,13.1547775 8.61815946,13.4330133 10.8511988,12.3428648 C13.0842381,11.2527163 14.5004429,8.98493222 14.5,6.5 L14.5,5"
                                        id="Shape"
                                    />
                                    <polyline id="Shape" points="0.5 7 1.5 8 2.5 7" />
                                    <polyline id="Shape" points="15.5 6 14.5 5 13.5 6" />
                                    <path
                                        d="M10,7.5 L10,9 C10,9.27614237 9.77614237,9.5 9.5,9.5 L6.5,9.5 C6.22385763,9.5 6,9.27614237 6,9 L6,7.5"
                                        id="Shape"
                                    />
                                    <polyline id="Shape" points="5 6 8 3.5 11 6" />
                                </g>
                            </g>
                        </g>
                    </g>
                </g>
            </g>
        </svg>
    );
}
